import { generateReducer, } from "../generators/generator.reducer";
import { GENERATOR_PARAMS } from "./settlement.constants";
var getExtraDefaultState = function (state) { return ({}); };
var reducer = generateReducer(GENERATOR_PARAMS, getExtraDefaultState);
export var SettlementReducer = reducer;
